export default {
  /**
   * 统计
   */

  getSpaceTableData:"/bygStatistics/findDmCount",
  getProductTableData:"/bygStatistics/findProductCount",
  downloadStatistics:"/bygStatistics/export"

}



// WEBPACK FOOTER //
// ./src/api/Statistics/urls.js